// layouts/catalogos/services/generos.js
import api from "services/api";

const ENDPOINT = "/genre";

export async function listGeneros(params = {}) {
  const { data } = await api.get(ENDPOINT, { params });
  // ajusta a como responda tu backend
  if (Array.isArray(data)) return { rows: data, total: data.length };
  return {
    rows: data.rows ?? data.page ?? data.data ?? [],
    total: data.total ?? data.count ?? data.totalCount ?? 0,
  };
}

export async function getGeneroById(id) {
  const { data } = await api.get(`${ENDPOINT}/${encodeURIComponent(id)}`);
  return data?.data ?? data ?? {};
}

export async function createGenero(payload) {
  const { data } = await api.post(ENDPOINT, payload, {
    headers: { "Content-Type": "application/json" },
  });
  return data?.data ?? data;
}

export async function updateGenero(id, payload) {
  const { data } = await api.put(`${ENDPOINT}/${encodeURIComponent(id)}`, payload, {
    headers: { "Content-Type": "application/json" },
  });
  return data?.data ?? data;
}

export async function deleteGenero(id) {
  const { data } = await api.delete(`${ENDPOINT}/${encodeURIComponent(id)}`);
  return data?.data ?? data;
}